import { Map, List } from 'immutable'
import {
  CONTENT_TYPE_SERIES,
  CONTENT_TYPE_VIDEO,
  CONTENT_TYPE_PERSON,
  CONTENT_TYPE_ARTICLE,
  CONTENT_TYPE_TAG,
  CONTENT_TYPE_GUIDE,
  CONTENT_TYPE_GUIDE_DAY,
  CONTENT_TYPE_PROMOTION,
  CONTENT_TYPE_FAQ,
  CONTENT_TYPE_PRODUCT,
  CONTENT_TYPE_BONUS_PACKAGE,
  CONTENT_TYPE_COURSE,
  CONTENT_TYPE_COURSE_MODULE,
} from '../../../services/content/content-types'

export default List([
  Map({ label: 'Please select a content type', value: '' }),
  Map({ label: 'Video', value: CONTENT_TYPE_VIDEO }),
  Map({ label: 'Series', value: CONTENT_TYPE_SERIES }),
  Map({ label: 'Person', value: CONTENT_TYPE_PERSON }),
  Map({ label: 'Article', value: CONTENT_TYPE_ARTICLE }),
  Map({ label: 'Tag', value: CONTENT_TYPE_TAG }),
  Map({ label: 'Guide', value: CONTENT_TYPE_GUIDE }),
  Map({ label: 'Guide day', value: CONTENT_TYPE_GUIDE_DAY }),
  Map({ label: 'Promotion', value: CONTENT_TYPE_PROMOTION }),
  Map({ label: 'Faq', value: CONTENT_TYPE_FAQ }),
  Map({ label: 'Product', value: CONTENT_TYPE_PRODUCT }),
  Map({ label: 'Course', value: CONTENT_TYPE_COURSE }),
  Map({ label: 'Course Module', value: CONTENT_TYPE_COURSE_MODULE }),
  Map({ label: 'Bonus Package', value: CONTENT_TYPE_BONUS_PACKAGE }),
])
